import React from 'react';
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom"; // Import Outlet

import './index.css';

// --- Assume these components are correctly defined and exported from these paths ---
import Header from './components/Landing/Header';
import Section from './components/Landing/Section';
import Services from './components/Services/Services';
import Preview from './components/Preview/Preview';
import Reviews from './components/Reviews/Reviews'; // Used in two places
import MapEmbed from './components/Reviews/MapEmbed';
import Details from './components/Closer/Details';
import Contact from './components/Contact/Contact';
// Shop Components
import Shop from './components/Shop/Shop';
import ProductDetail from './components/Shop/ProductDetail';
import Checkout from './components/Shop/Checkout';
import { ShopProvider } from './components/Shop/ShopContext';
import StripeWrapper from './components/Shop/StripeWrapper';
import Success from './components/Shop/Success';
// --- End Assumption ---


// 1. Define the Layout Component (or import it if it's in another file)
// This component wraps your page content and MUST include <Outlet />
// to render the content of the nested routes.
const Layout = () => {
  return (
    <div>
      {/* You could put a persistent Navbar or Footer here if needed */}
      {/* <Navbar /> */}
      <Header />
      <main>
        {/* Outlet is the placeholder where child route elements will be rendered */}
        <Outlet />
      </main>
      {/* <Footer /> */}
    </div>
  );
};

// Shop Layout component to wrap all shop routes with the ShopProvider
const ShopLayout = () => {
  return (
    <ShopProvider>
      {/* <Header /> */}
      <main>
        <Outlet />
      </main>
    </ShopProvider>
  );
};

// LandingPage component that combines all landing page sections
const LandingPage = () => {
  return (
    <>
      <Section />
      <MapEmbed />
      <Details />
    </>
  );
};

// 2. Your Updated App Component
const App = () => {
  // Log current environment and API URL
  console.log('Current environment:', import.meta.env.MODE);
  console.log('API URL:', import.meta.env.VITE_API_URL);
  console.log('Stripe Key:', import.meta.env.VITE_STRIPE_PUBLIC_KEY);

  return (
    <BrowserRouter>
      <Routes>
        {/* The Layout component wraps all routes defined within it */}
        <Route path="/" element={<Layout />}>
          {/* Index Route: Renders inside Layout's <Outlet /> when path is exactly "/" */}
          <Route index element={<LandingPage />} />
          
          {/* Reviews Route: Renders inside Layout's <Outlet /> when path is "/reviews" */}
          <Route path="gallery" element={<Preview />} />
          {/* <Route path="signup" element={<Contact />} /> */}

          {/* Shop Routes - All wrapped with ShopProvider */}
          <Route element={<ShopLayout />}>
            <Route path="shop" element={<Shop />} />
            <Route path="shop/product/:productId" element={<ProductDetail />} />
            <Route path="shop/checkout" element={<Checkout />} />
            <Route path="success" element={<Success />} />
          </Route>
          
          {/* <Route path="*" element={<NotFound />} /> */} {/* Catch-all route */}
        </Route>

        {/* You could define other top-level routes here if they don't use the Layout */}
        {/* <Route path="/login" element={<LoginPage />} /> */}
      </Routes>
    </BrowserRouter>
  );
};

export default App;